export default "__VITE_ASSET__ec0e0e80__"